export type SensorFrame3D = {
  cloudUrl: string;
  groundUrl?: string;
};

export class SensorRendererState3D {
  constructor(
    public sensorFrames: Array<SensorFrame3D | undefined> = [],
    public height = 0,
    public width = 0,
  ) {}
}
